import React, { useRef, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useQueryClient } from '@tanstack/react-query';
import { Button } from '@mui/material';
import { userHasPermission } from 'app/../utils';
import SensitiveInfoDialog from 'app/custom-widgets/dialogs/SensitiveInfoDialog';
import { updateQueryCache } from 'app/data/optimistic-update-utils';

const BankingDetails = ({ buttonProps, requiredPermission, props, user }) => {
    const { getValues } = useFormContext();
    const userRef = useRef(user);
    const [showSensitiveInfo, setShowSensitiveInfo] = useState(false);
    const canEditSensitiveInfo = userHasPermission(requiredPermission);
    const queryClient = useQueryClient();

    const refetch = async () => {
        // on successful update, we need to refetch the user
        // after refetching, we overwrite the cache with any values user has updated
        userRef.current = getValues();
        await queryClient.refetchQueries({ queryKey: ['user-data'] });
        const updatedUser = { ...userRef.current };
        delete updatedUser.bank_account_number;
        delete updatedUser.bank_routing_number;
        delete updatedUser.bank_name;
        delete updatedUser.ach_record_type;
        delete updatedUser.bank_transaction_code;
        updateQueryCache(queryClient, ['user-data'], updatedUser);
        return updatedUser;
    };

    if (!canEditSensitiveInfo) return null;

    const { label, variant, type, ...rest } = props;
    return (
        <>
            <Button variant="contained" color="primary" onClick={() => setShowSensitiveInfo(true)} {...buttonProps}>
                {label}
            </Button>
            <SensitiveInfoDialog
                title="Edit Banking Details"
                dataType="Producer"
                data={user}
                open={showSensitiveInfo}
                setOpen={setShowSensitiveInfo}
                showOnlyDialog
                forceFetch={refetch}
                {...rest}
                // wrap
            />
        </>
    );
};

export default BankingDetails;
